<template>
    <div> 
		<div  v-if="tradingAccountList.totalLiveAccounts > 0">
			<div>
				<div class="mainTitle text-center mt-4 mb-3"> 
					<h2 class=" mb-3">{{$t('sub_SubliveAcc')}}</h2>
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
					<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
				</div> 
				<!--loader - message--->
				<div class="CustomBlockWidth"> 
					<div class="justify-content-center d-flex"> 
						<div class="middleBox">
							<div class="whiteBG p-4">
								<!---------------------request form----------------------->
								<div class="partcipate-fund" v-if="trans_id == '' && !congModule"> 
									<div class="clearfix"></div>
									<div class="form-group field-wrapper mb-4">
										<account-id></account-id>
									</div>	
									<div class="form-group text-center mb-0">
											<button class="prism_btn btn_sm" v-on:click.prevent="SubscribeAcc()">{{$t('sub_subscribe')}}</button>
									</div>
									<div class="signupbtn  text-center mt-3  ">
										<a href="#" class="underline" v-on:click.prevent="$parent.SubscribeForm = false">{{$t('sub_backtradingTool')}}</a>
									</div>
								</div>
								<!------------------------------------------------------------>
								<div class="partcipate-fund" v-else-if="trans_id != '' && !congModule">
									<div> 
										<h3 class="mb-3 text-center">{{$t('sub_enterotp')}}</h3>
										<div class="form-group field-wrapper mb-4">
											<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedPasswordOtp && errors.has('otp') }" ref="otpInput">
											<p v-for="error in errors.collect('otp')">{{ error }}</p>
										</div> 
										
											
											<div class="form-group text-center mb-3  ">
												<button class="prism_btn btn_sm " v-on:click.prevent="cofirmOtp()">{{$t('sub_validate')}} </button>
											</div>
											
										
										<div class="d-flex justify-content-center align-items-center w-100">
											<div class="signupbtn text-center mr-4">
												<a href="#" class="underline" v-on:click.prevent="resendOtp()">{{$t('sub_resendOtp')}}</a>
											</div>
											<div class="signupbtn text-center ">
												<a href="#" class="underline" v-on:click.prevent="$parent.SubscribeForm = false">{{$t('sub_backtradingTool')}}</a>
											</div>
										</div>
										
									</div>
								</div>
								<!---------------------congo-message-------------->
								<div class="stepForm middleBox" v-else-if="congModule">
									<div class="congratulations">
										<div class="logo_congrats">
											<img src="../../../../static/fxView/images/check.svg" alt="Icon">
										</div>
										<div class="subtitle">
											<h3>{{$t('sub_congo')}} <span class="green">{{get_user.username}}</span></h3>
											<ul class="includeWdth">
												<li><strong>{{$t('sub_tradingId')}}</strong> {{account_id}}</li>
											</ul>
										</div>
										<div class="signupbtn full-width submitButton w-100 mt-4 text-center">
											<a href="#" class="prism_btn btn_sm"  v-on:click.prevent="$parent.SubscribeForm = false">{{$t('sub_backtradingTool')}}</a>
										</div>
									</div>  
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="tradingAccountList.totalLiveAccounts == 0">
            <div class="mainTitle  text-center my-3">
                <h3>{{$t('rb_noTradingAccFound')}}</h3>
            </div>
            <no-trading-account :demo_live_both="'no'"></no-trading-account>
        </div>
		<div v-else class="text-center p-5 customLoader"> 
			<div class="loader"></div>  
            <h4>{{$t('rb_plzWaitWhileProc')}}</h4>
        </div>
    </div>
</template>
<script>
    import twoFa from '../users/2FA'
    export default {
        name: 'Change-Password',
        data() {
            return {
				pageName : 'subscribe-account',
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
                come_from_manage_page : false,
				//-----select account----
				selectAccount : false,
                account_id : '',
				act_account_id : '',
				demo_live : '',
				platform :'', 
				//------------------------
                password : '',
                con_password : '',
                submitted : false,
				mszValidationAcco : false,

                otp : '',
                submittedPasswordOtp : false,
                trans_id : '',
                congModule : false,
                authComponent : false,
                request_page : 'subscribe-account',
				mszValidation : ''
            }
        },
        components: {
            appTwofa: twoFa
        },
        methods:{
            resendOtp(){
				let input_json={
					'globalParams' :{
						'trans_id' : this.trans_id.toString()
					},
					'localParams' :{ "parameter" : this }
				}
				this._runTicketResendOtp(input_json)
			},
            //==================password===================
            SubscribeAcc(){
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
						let bankForm = document.getElementById('bankForm');
	                    let comment = _that.$t('sub_addtradertool')+ _that.account_id
	                    let form_name = new FormData();
	                    form_name.append("subject", 'Add Trader Tool Box');
	                    form_name.append("text",comment);
	                    form_name.append("document[]",'');
	                    form_name.append("account_id",_that.account_id);
	                    form_name.append("reason", '115');
	                    form_name.append("reason_text", 'Trader_tool_box');
	                    form_name.append("title", '0');
	                    form_name.append("title_text", '');
                        let input_json={
                            'globalParams' :{
                                'form' : form_name
                            },
                            'localParams' :{ "parameter" : _that , 'module' : 'ticket-reply'  }
                        }
                        _that._runTicketRequestOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            cofirmOtp(){
                const _that = this
                this.submittedPasswordOtp = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'otp' : _that.otp.toString() ,
                                'trans_id' : _that.trans_id.toString()
                            },
                            'localParams' :{ "parameter" : _that,page:'subscribe' }
                        }
                        _that._runTicketCheckOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            reset(){
				this.act_account_id = ''
                this.account_id = ''
                this.password = ''
				this.demo_live = ''
				this.platform = ''
                this.submitted = false
            }
        },
        created(){
            if(this.$route.params.account_id){
                this.come_from_manage_page = true
                this.account_id = this.$route.params.account_id
				this.act_account_id = this.$route.params.act_account_id
				this.demo_live = this.$route.params.demo_live
				this.platform = this.$route.params.platform
            }
			this._runGetTradingAccountList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
        },
		mounted() { 
			const _that = this
            $(document).on("click", function(event){
				if(!$(event.target).closest('.SelectAcntList').length){
                    _that.selectAccount = false
                }
            });
			
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/subscribe_account.vue